export enum UserStatus {
    Available = 1,
    Busy = 2,
    DoNotDisturb = 3,
    BeRightBack = 4,
    AppearAway = 5,
    Offline = 6
}